var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container",on:{"click":function($event){return _vm.$emit('click',{})}}},[_c('strong',{staticClass:"text"},[_vm._v("No hay información")]),_c('i',{staticClass:"fa fa-refresh icon"})])])}
var staticRenderFns = []

export { render, staticRenderFns }